
import { useState } from 'react';
import { CartItem, Produto, AdicionalItem } from '../types';

export const useCarrinho = () => {
  const [cart, setCart] = useState<CartItem[]>([]);

  const addToCart = (product: Produto, qty: number, obs: string, addons: AdicionalItem[]) => {
    const newItem: CartItem = {
      ...product,
      quantidade: qty,
      observacao: obs,
      adicionais_selecionados: addons
    };
    setCart(prev => [...prev, newItem]);
  };

  const updateQuantity = (id: string, delta: number, index?: number) => {
    setCart(prev => {
      const newCart = [...prev];
      if (index !== undefined) {
        newCart[index].quantidade += delta;
        if (newCart[index].quantidade <= 0) newCart.splice(index, 1);
      }
      return newCart;
    });
  };

  const clearCart = () => setCart([]);

  const total = cart.reduce((acc, item) => {
    const addPrice = item.adicionais_selecionados?.reduce((a, ad) => a + ad.preco, 0) || 0;
    return acc + ((item.preco + addPrice) * item.quantidade);
  }, 0);

  return { cart, addToCart, updateQuantity, clearCart, total };
};
